<template>
  <div>
    <PageHeading title="Novo picker" :pieces="['Pickers', 'Novo picker']" />
    <div class="row">
      <div class="col-lg-12">
        <div class="wrapper wrapper-content">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">Preencha os dados abaixo do novo usuário picker:</h5>
              <div class="card-body">
                <form @submit.prevent="doRegister()" id="basicform" data-parsley-validate>
                  <div class="form-group">
                    <label for="inputUserName">Nome</label>
                    <input
                      v-model="picker.name"
                      id="inputUserName"
                      type="text"
                      name="name"
                      data-parsley-trigger="change"
                      required
                      placeholder
                      :disabled="isLoading"
                      autocomplete="off"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label for="cpf">CPF</label>
                    <input
                      v-model="picker.cpf"
                      id="cpf"
                      v-mask="'###.###.###-##'"
                      type="text"
                      name="cpf"
                      :disabled="isLoading"
                      data-parsley-trigger="change"
                      required
                      minlength="11"
                      placeholder
                      autocomplete="off"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group">
                    <label for="inputEmail">E-mail</label>
                    <input
                      v-model="picker.email"
                      id="inputEmail"
                      type="email"
                      name="email"
                      :disabled="isLoading"
                      data-parsley-trigger="change"
                      required
                      placeholder
                      autocomplete="off"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label for="inputPassword">Senha</label>
                    <input
                      v-model="picker.password"
                      id="inputPassword"
                      type="password"
                      placeholder
                      :disabled="isLoading"
                      required
                      class="form-control"
                    />
                  </div>

                  <div class="col-sm-13 pl-0">
                    <p class="text-right">
                      <button type="submit" class="btn btn-space btn-primary">
                        <span v-if="!isLoading">Criar usuário</span>
                        <span v-if="isLoading">Processando...</span>
                      </button>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- ============================================================== -->
          <!-- end basic form -->
          <!-- ============================================================== -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import * as firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/firestore";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";

import PageHeading from "@/views/admin/components/PageHeading.vue";
import { createNewPicker } from "@/services/picker";

export default {
  directives: {
    mask,
  },

  components: {
    PageHeading,
  },

  computed: {
    ...mapGetters(["userData"]),
  },

  data() {
    return {
      isLoading: false,
      picker: {
        name: "",
        cpf: "",
        email: "",
        password: "",
      },
    };
  },

  methods: {
    doRegister() {
      this.$data.isLoading = true;
      let picker = { ...this.$data.picker };
      createNewPicker({
        ...picker,
        supermarket: {
          id: this.userData.id,
          companyName: this.userData.companyName,
          tradeName: this.userData.tradeName,
        },
      })
        .then((result) => {
          this.$data.isLoading = false;
          if (result.status === 200) {
            const data = result.data;
            alert(data.message);
            if (data.code === "success") {
              this.$data.picker = {
                name: "",
                cpf: "",
                email: "",
                password: "",
              };
            }
          }
        })
        .catch((error) => {
          this.$data.isLoading = false;
          const data = error.response.data;
          alert(data.message);
        });
    },
  },
};
</script>